import React from 'react';
import { Text, View } from 'react-native';
import { useI18n } from '@shared/i18n/useI18n';

export const DocumentsEmpty = () => {
    const { t } = useI18n();

    return (
        <View className="flex-1 items-center justify-center px-lg">
            <Text className="text-center text-md font-semibold text-primary-700">{t('documents.empty')}</Text>
        </View>
    );
};
